module.exports = __webpack_public_path__ + "static/media/interactionNewKTM.bb158195.svg";